import { render, staticRenderFns } from "./ActionGetPdfFile.vue?vue&type=template&id=0304d4a5"
import script from "./ActionGetPdfFile.vue?vue&type=script&lang=js"
export * from "./ActionGetPdfFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports